const get = function (key) {

    try {
        let data = window.localStorage.getItem(key);
        if (!data) return undefined;

        data = JSON.parse(data);
        if (!data) return undefined;

        if(!data.expired) return undefined;

        if (data.expired < new Date().getTime() / 1000) {
            //已经过期
            window.localStorage.removeItem(key);
            return undefined;
        }

        return data.data;
    } catch (e) {
        return undefined;
    }

}

const del = function (key) {
    window.localStorage.removeItem(key);
}

const set = function (key, val, ttl = 180) {
    if (typeof val === 'object') {
        val = JSON.stringify(val);
    }

    let data = {
        data: val,
        expired: Math.ceil(new Date().getTime() / 1000) + parseInt(ttl)
    }

    window.localStorage.setItem(key, JSON.stringify(data));
}

export default {
    get,
    set,
    del
}
